exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn[data-v-21007e74]{margin:10px;padding:0 16px}.middle[data-v-21007e74]{padding:2px 4px 2px 2px}.tnc-title[data-v-21007e74]{text-transform:uppercase;font-weight:800;font-size:14px}.tnc[data-v-21007e74]{font-size:13px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-21007e74","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/membership_purchased.vue
// module id = q6uV
// module chunks = 0